/**
 * Restructed by he.zhikai
 * Restructed on 2017-11-17
 */
'use strict';
angular.module('reportSummaryNewsModule', ['util.ueditor', 'mgcrea.ngStrap.scrollspy']).controller('reportSummaryNewsCtrl', [
    '$scope',
    '$rootScope',
    '$sce',
    '$compile',
    '$window',
    '$state',
    '$timeout',
    '$stateParams',
    '$validation',
    '$filter',
    'trsHttpService',
    'initiWoDataService',
    'jsonArrayToStringService',
    'modalDialog',
    '$q',
    'initSingleSelecet',
    'iWoService',
    'myManuscriptService',
    'editingCenterService',
    'initeditctrBtnsService',
    'filterEditctrBtnsService',
    'iWoinitBtnService',
    'iWoBtnService',
    'storageListenerService',
    'localStorageService',
    'ueditorService',
    'sensitiveWordCheckService',
    function(
        $scope,
        $rootScope,
        $sce,
        $compile,
        $window,
        $state,
        $timeout,
        $stateParams,
        $validationProvider,
        $filter,
        trsHttpService,
        initiWoDataService,
        jsonArrayToStringService,
        modalDialog,
        $q,
        initSingleSelecet,
        iWoService,
        myManuscriptService,
        editingCenterService,
        initeditctrBtnsService,
        filterEditctrBtnsService,
        iWoinitBtnService,
        iWoBtnService,
        storageListenerService,
        localStorageService,
        ueditorService,
        sensitiveWordCheckService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.status = {
                newsFormError: [],
                nopayment: false,
                // 新增start
                switch: 'manuscriptInfo', // 默认选中稿件信息
                support: {
                    content: '', // 提交给辅助写作的纯文本
                },
                showSearch: false,
                huyan: false,
                zhengwen: false,
                showColor: false,
                // end
                openBtn: true,
                mediaTypes: [],
                selectMediaTypes: {},
                isRequest: false,
                bigFaceSwitch: { status: false },
                sensitiveWordTit: '敏感词校验',
                newsDocSaveMethod: ['savePersonalNews', 'saveReceivedNews'],
                titleRule: 'maxlength=50',
                hasVersionTime: false,
                audioVideoidsArray: [], // 播放音视频临时数组
                uploadMasProgress: 0,
                uploadMasNow: false,
                masUploadExtensions: 'mp3,mp4,flv,rmvb,avi',
                masUploadMimeTypes: 'audio/mp3,video/mp4,video/flv,video/rmvb,video/avi',
                isCheckSensitiveWords: false,
                isEditDraft: !!$stateParams.iwometadataid,
                metadataid: $stateParams.iwometadataid,
                showVideoAudioDiv: false,
            };
            $scope.data = {
                // 新增start
                manuscriptFrom: 0,
                articleTitleNum: '',
                fgd: 1,
                listStyle: 1,
                label: 'tufa',
                focusImg: 1,
                wordNum: '',
                focusDesNum: '',
                focusTitleNum: '',
                KEYWORDS: [],
                // end
                copyVersion: [],
                comment: {
                    comment: [],
                    voiceObj: {},
                    hasMore: false,
                    currPage: 1,
                },
                lastVersionid: '',
                path: {
                    '-1': 'editingCenterIwoPersonalVersionTime',
                    '1': 'editingCenterAppPersonalVersionTime',
                    '2': 'editingCenterWebsitePersonalVersionTime',
                    '3': 'editingCenterPaperPersonalVersionTime',
                    '4': 'editingCenterWeixinPersonalVersionTime',
                },
                selectedVideoArray: [], // 选择的视频
                originList: [
                    {
                        name: '内部原创',
                        value: '2',
                    },
                    {
                        name: '整合原创',
                        value: '1',
                    },
                    {
                        name: '特约稿',
                        value: '3',
                    },
                    {
                        name: '通讯员稿',
                        value: '4',
                    },
                    {
                        name: '报道组稿',
                        value: '5',
                    },
                    {
                        name: '其他',
                        value: '6',
                    },
                ],
            };
            //  $anchorScroll.yOffset = 63;
            // 初始化按钮点击
            $scope.handleBtnClick = function(funname) {
                eval('$scope.' + funname + '()');
            };
            emitCloseWindow();
            getUserHeadPic();
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function() {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.newsForm.$error) {
                errorArray.push(error);
            }
            $scope.status.newsFormError = $scope.status.newsFormError == undefined ? [] : $scope.status.newsFormError;
            if ($scope.status.newsFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.newsFormError = errorArray;
            }
            return $scope.status.newsFormError; // 返回
        };

        /**
         * [getUserHeadPic description] 获取用户头像
         * @return {[type]} [description]
         */
        function getUserHeadPic() {
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getUserHeadPic',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.headPic = data.USERHEAD[0].PERPICURL == '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
            });
        }

        /**
         * [description] 监听用户头像变化
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        $rootScope.$on('updateHeadPortrait', function(event, data) {
            getUserHeadPic();
        });

        /**
         * [initOrigin description]初始化原创
         * @return {[type]} [description]
         */
        function initOrigin() {
            // 新增
            $scope.data.typeList = [
                {
                    name: '全部',
                    value: '1',
                },
                {
                    name: '文字',
                    value: '2',
                },
                {
                    name: '图片',
                    value: '3',
                },
                {
                    name: '音视频',
                    value: '4',
                },
            ];
            // end
            if ($stateParams.iwometadataid) {
                $scope.status.nopayment = true;
                for (var i = 0; i < $scope.data.originList.length; i++) {
                    if ($scope.list.ORIGINALTYPE == $scope.data.originList[i].value) {
                        $scope.checkOrigin($scope.data.originList[i]);
                        break;
                    }
                }
                $scope.data.specialDoc = $scope.list.SPECIALDOC;
            } else {
                $scope.list.ORIGINAL = '0';
                $scope.data.specialDoc = 0;
            }
        }

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            window.onbeforeunload = function() {
                localStorageService.set('unLocakDraft', { metadataid: $stateParams.iwometadataid });
            };
        }

        /**
         * [initData description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initData() {
            storageListenerService.removeListener('iwo');
            initMediaTypes();
            if ($stateParams.iwometadataid) {
                // 编辑
                $scope.params = {
                    serviceid: 'mlf_myrelease',
                    methodname: 'getNewsDoc',
                    MetaDataId: $stateParams.iwometadataid,
                };
                // 编辑显示大花脸
                iWoService.initData().then(function(data) {
                    // 初始化页面参数
                    $scope.DOCGENRES = data.DocGenre;
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                        $scope.list = data;
                        initVideoArr();
                        $scope.list.MEDIATYPES = data.MEDIATYPES_DB;
                        // 获取流程版本与操作日志
                        getVersion().then(function(data) {
                            loadDirective().then(function() {
                                $scope.status.showVideoAudioDiv = true;
                            });
                        });
                        initKeyWords();
                        // 初始化原创类型
                        initOrigin();
                    });
                    // 获取评审意见
                    getComment($stateParams.iwometadataid, $scope.data.comment.currPage);
                });
            } else {
                $scope.list = initiWoDataService.initNews();
                initDocgenre();
                loadDirective().then(function() {
                    $scope.status.showVideoAudioDiv = true;
                });
                initKeyWords();
                initOrigin();
            }
            initArrayBtn();
        }

        function initVideoArr() {
            var data = $scope.list.VIDEOREL;
            $scope.status.audioVideoidsArray = angular.copy(data);
            for (var i = 0; i < data.length; i++) {
                var url = $sce.trustAsResourceUrl(data[i].URL);
                $scope.status.audioVideoidsArray[i].value = {
                    streamsMap: {
                        l: {
                            httpURL: url,
                        },
                    },
                };
            }
        }
        // 锚点切换开始
        //  $scope.goto = function(id) {
        //      $location.hash(id);
        //      $anchorScroll();
        //  };
        /**
         * [close description]页面关闭
         * @return {[type]} [description]
         */
        $scope.close = function() {
            if ($scope.status.editVideoTranscoding) {
                aboutVideoCloseView('温馨提示', '有编辑完成的视频正在转码中，关闭将无法保存，是否直接关闭？', 'error', true);
            } else if (isVideoArrayChanged()) {
                aboutVideoCloseView('温馨提示', '视频有更改，关闭将无法保存，是否直接关闭？', 'warning', true);
            } else {
                closeCurrView();
            }
        };
        // 关闭页面方法
        function closeCurrView() {
            editingCenterService
                .closeWinow($scope.newsForm.$dirty, ueditorService.contentTranscoding($scope.list) != ueditorService.bindContent())
                .then(
                    function() {
                        save().then(function() {
                            storageListenerService.addListenerToIwo('newsSaved');
                            var opened = $window.open('about:blank', '_self');
                            opened.close();
                        });
                    },
                    function() {
                        var opened = $window.open('about:blank', '_self');
                        opened.close();
                    }
                );
        }
        // 被视频影响的衍生出来的关闭页面方法（含提醒）
        function aboutVideoCloseView(bigWord, smallWord, status, hasCancelBtn) {
            if ($scope.newsForm.$dirty || ueditorService.contentTranscoding($scope.list) != ueditorService.bindContent()) {
                closeCurrView();
            } else {
                modalDialog.alertType(bigWord, smallWord, status, hasCancelBtn, function() {
                    var opened = $window.open('about:blank', '_self');
                    opened.close();
                });
            }
        }
        // 空格增加关键词
        $scope.addkeywords = function(e) {
            if (e.keyCode == 32 && $scope.list.KEYWORDS.indexOf($scope.keywordTxt) < 0) {
                $scope.data.KEYWORDS.push($scope.keywordTxt);
                $scope.keywordTxt = '';
            }
        };

        $scope.removeRelate = function(index, type) {
            if (type == 'rN') {
                $scope.list.RELEVANTNEWS.splice(index, 1);
            } else if (type == 'rOf') {
                $scope.list.RELEVANTOFFICIALS.splice(index, 1);
            }
        };
        // 新增start
        // 改变编辑器背景色
        $scope.changeEditBackcol = function(boolean, color) {
            $scope.status.showColor = false;
            $('ueditorlocation #ueditor_0')
                .contents()
                .find('body')
                .css('background', color);
            //  $(angular.element(document)).find('ueditorLocation iframe .view').css("background",color);
        };
        // end
        // 删除关键词
        $scope.delete = function(record) {
            $scope.list.KEYWORDS.splice(record, 1);
        };
        // 更新状态
        $scope.updateSelection = function(item) {
            $scope.list.MEDIATYPES = item.value;
        };
        // 原创声明
        $scope.oringin = function(list) {
            if (list.ORIGINAL === '1') {
                $scope.list.ORIGINAL = '0';
                $scope.data.originType = '0';
            } else {
                $('.newsResourcesTips')
                    .find('.tips')
                    .remove();
                $scope.list.ORIGINAL = '1';
                $scope.data.originType = $scope.data.originList[0].value;
                $scope.data.specialDoc = 0;
            }
            if (!$scope.status.nopayment) {
                $scope.status.nopayment = true;
                $scope.list.ISNOPAYMENT = '0';
            }
        };
        // 点击特殊稿
        $scope.specialDoc = function() {
            if ($scope.data.specialDoc == 1) {
                $scope.data.specialDoc = 0;
            } else {
                $('.newsResourcesTips')
                    .find('.tips')
                    .remove();
                $scope.data.specialDoc = 1;
                $scope.list.ORIGINAL = '0';
                $scope.data.originType = '0';
            }
        };
        // 勾选原创稿二级单选的原创类型
        $scope.checkOrigin = function(item, type) {
            $('.newsResourcesTips')
                .find('.tips')
                .remove();
            $scope.data.originType = item.value;
            $scope.list.ORIGINAL = '1';
            $scope.data.specialDoc = 0;
            if (!$scope.status.nopayment && !!type) {
                $scope.status.nopayment = true;
                $scope.list.ISNOPAYMENT = '0';
            }
        };
        $scope.updateCKSelection = function(list) {
            list.ISNOPAYMENT === '1' ? (list.ISNOPAYMENT = '0') : (list.ISNOPAYMENT = '1');
        };

        /**
         * [manageSaveObjBeforeSave description]在保存前处理保存对象
         * @return {[type]} [description]
         */
        function manageSaveObjBeforeSave() {
            saveVideoRel();
            getKeyWords();
            $scope.list.serviceid = 'mlf_newreport'; // 在编辑时后台为返回服务名
            $scope.list.METHODNAME = $scope.status.newsDocSaveMethod[$stateParams.iwoplatform];
            $scope.list.PLATEFORM = $stateParams.iwoplatform;
            $scope.list.ReportId = $stateParams.reportId;
            $scope.list.DOCRELTIME = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm').toString();
            $scope.list.ORIGINALTYPE = $scope.data.originType;
            $scope.list.SPECIALDOC = $scope.data.specialDoc;
            var list = angular.copy($scope.list);
            // 删除多余字段开始
            delete list.RELEVANTNEWS;
            delete list.RELEVANTOFFICIALS;
            delete list.OBJ_VERSION;
            delete list.LOG_OPERATION;
            delete list.FZ_DOCS;
            // 删除多余字段结束
            // 处理发稿单作者信息空数据提交问题
            if (
                angular.isDefined(list.FGD_AUTHINFO[0]) &&
                (!angular.isDefined(list.FGD_AUTHINFO[0].USERNAME) || list.FGD_AUTHINFO[0].USERNAME === '')
            ) {
                list.FGD_AUTHINFO = [];
            }
            // 处理发稿单作者信息空数据提交问题
            // NEWSSOURCES为空时传空字符串
            list.NEWSSOURCES = !$scope.list.NEWSSOURCES.SRCNAME ? '' : angular.copy($scope.list.NEWSSOURCES);
            // JSON对象数组转字符串
            list = jsonArrayToStringService.jsonArrayToString(list);
            list.HTMLCONTENT = list.HTMLCONTENT.replace(
                /_ueditor_page_break_tag_/g,
                "<hr class='pagebreak' noshade='noshade' size='5' style='-webkit-user-select: none;'>"
            );
            return list;
        }

        /**
         * [manageDataAfterSave description]保存操作完成后进行数据处理
         * @param  {[type]} data [description]保存后的返回值
         * @param  {[type]} flag [description]调用保存服务后是否弹出成功窗口判断
         * @return {[type]}      [description]
         */
        function manageDataAfterSave(data, flag) {
            $scope.list.METADATAID = data.METADATAID;
            $scope.list.CHNLDOCID = data.CHNLDOCID;
            $scope.status.isEditDraft = true;
            $stateParams.iwochnldocid = $scope.list.CHNLDOCID;
            $stateParams.iwometadataid = $scope.list.METADATAID;
            $scope.data.incomeData = [
                {
                    TITLE: $scope.list.TITLE,
                    CHNLDOCID: $stateParams.iwochnldocid,
                    METADATAID: $stateParams.iwometadataid,
                },
            ];
            if (flag) {
                storageListenerService.addListenerToIwo('newsSaved');
                $state.transitionTo($state.current, $stateParams, {
                    reload: false,
                });
                $timeout(function() {
                    modalDialog.saveModel('保存成功', '', 'success');
                }, 500);
            } else {
                $scope.params = {};
            }
        }

        function saveContent() {
            ueditorService.saveContent($scope.list);
        }
        // 保存
        $scope.save = function(type) {
            var ue = UE.getEditor('ueditor');

            save(true).then(function() {
                getVersion($scope.list.METADATAID);
                var params = {
                    serviceid: 'mlf_myrelease',
                    methodname: 'getNewsDoc',
                    MetaDataId: $scope.list.METADATAID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    ue.ready(function() {
                        ue.setContent(data.HTMLCONTENT);
                        ueditorService.saveToLocal($scope.list.METADATAID, $scope.data.lastVersionid);
                    });
                });
            });
        };

        /**
         * [save description]稿件保存方法
         * @param  {[Boolean]} flag [description]标识
         * @return {[type]}      [description]
         */
        function save(flag) {
            var deferred = $q.defer();
            var ue = UE.getEditor('ueditor');
            saveContent();
            $timeout(function() {
                $validationProvider.validate($scope.newsForm.authorForm);
                $scope.newsForm.$pending = {};
                $validationProvider
                    .validate($scope.newsForm)
                    .success(function() {
                        modalDialog.isSecretInformation(
                            undefined,
                            function() {
                                sensitiveWordCheckService.sensitiveWords($scope).then(
                                    function(sensitiveWords) {
                                        $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                        $scope.list.SENSITIVEWORDS = sensitiveWords;
                                        ueditorService.saveToLocal($scope.list.METADATAID);
                                        $scope.newsForm.$setPristine();
                                        $scope.status.openBtn = false;
                                        var list = manageSaveObjBeforeSave();
                                        $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', list, 'post').then(
                                            function(data) {
                                                $scope.status.openBtn = true;
                                                manageDataAfterSave(data, flag);
                                                deferred.resolve(data);
                                            },
                                            function(data) {
                                                $scope.status.openBtn = true;
                                                deferred.reject(data);
                                            }
                                        );
                                    },
                                    function(data) {
                                        // 有敏感词，并且点击确定修改敏感词
                                        $scope.status.isCheckSensitiveWords = Math.random();
                                    }
                                );
                            },
                            function() {}
                        );
                    })
                    .error(function(msg) {
                        editingCenterService.checkSaveError($scope.newsForm, angular.element('form'), $scope); // 定位输入错的表单位置
                        modalDialog.saveModel('保存失败', '请检查填写项', 'error');
                    });
            });
            return deferred.promise;
        }
        // 保存结束
        // 多渠道提交触发
        $scope.iWoSubmit = function() {
            var methodname = ['personalSubmitMedia', 'receivedSubmitMedia'];
            save(false).then(function() {
                saveSubmit(methodname[$stateParams.iwoplatform]);
            });
        };
        // 多渠道提交函数
        /**
         * [saveSubmit description] 多渠道提交函数
         * @param   {[type]}  methodname  [methodname description]
         * @return  {[type]}              [return description]
         */
        function saveSubmit(methodname) {
            myManuscriptService.submit(
                $scope.data.incomeData,
                function() {
                    storageListenerService.addListenerToIwo('newsSubmit');
                    var opened = $window.open('about:blank', '_self');
                    opened.close();
                },
                function() {},
                methodname
            );
        }
        // 多渠道提交函数结束
        // 共享触发（个人稿库+已收稿库）
        $scope.iWoshare = function() {
            //  modalDialog.isSecretInformation(function() {
            save(false).then(function(data) {
                saveShare(data.METADATAID, data.CHNLDOCID);
            });
            //  }, function() {

            //  });
        };

        /**
         * [saveShare description] 共享函数
         * @param   {[type]}  metadataid  [metadataid description]
         * @param   {[type]}  chnldocid   [chnldocid description]
         * @return  {[type]}              [return description]
         */
        function saveShare(metadataid, chnldocid) {
            var shareMethod = ['personalMyShare', 'receivedMyShare'];
            editingCenterService.share(function(data) {
                data.serviceid = 'mlf_myrelease';
                data.methodname = shareMethod[$stateParams.iwoplatform];
                data.ChnlDocIds = chnldocid;
                data.MetaDataIds = metadataid;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), data, 'post').then(function(data) {
                    modalDialog.alertType('共享成功', '', 'success', false, function() {
                        storageListenerService.addListenerToIwo('newsShared');
                        var opened = $window.open('about:blank', '_self');
                        opened.close();
                    });
                });
            });
        }
        // 共享函数结束
        //  传稿(个人稿库+已收稿库)
        $scope.iWoTransfer = function() {
            //  modalDialog.isSecretInformation(function() {
            save(false).then(function() {
                draft();
            });
        };

        /**
         * [draft description] 传稿
         * @return  {[type]}  [return description]
         */
        function draft() {
            var menthod = ['personalTransferMetaDatas', 'receivedTransferMetaDatas'];
            myManuscriptService.draft(
                '传稿',
                $scope.data.incomeData,
                function() {
                    storageListenerService.addListenerToIwo('newsPassed');
                    var opened = $window.open('about:blank', '_self');
                    opened.close();
                },
                function() {},
                menthod[$stateParams.iwoplatform]
            );
        }
        // 传稿函数结束
        /**
         * [getKeyWords description] 获取关键词
         * @return  {[type]}  [return description]
         */
        function getKeyWords() {
            $scope.list.KEYWORDS = '';
            angular.forEach($scope.data.KEYWORDS, function(data, index, array) {
                if (index != $scope.data.KEYWORDS.length - 1) {
                    $scope.list.KEYWORDS += data.name + ';';
                } else {
                    $scope.list.KEYWORDS += data.name;
                }
            });
        }

        /**
         * [getSuggestions description]获取suggestion
         * @param  {[str]} viewValue [description]输入框内输入值
         * @return {[type]}           [description]
         */
        $scope.getSuggestions = function(viewValue) {
            var searchParams = {
                serviceid: 'mlf_personalsource',
                methodname: 'getRecentUsageSources',
                SrcName: viewValue,
            };
            return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchParams, 'post').then(function(data) {
                return data;
            });
        };

        /**
         * [description]Suggestion 监听
         */
        $scope.$watch('list.NEWSSOURCES', function(newValue, oldValue, scope) {
            if (!angular.isObject(newValue)) {
                $scope.status.isRequest = true;
                newValue = {
                    SOURCEID: '0',
                    SRCNAME: newValue,
                };
            }
            if (angular.isDefined($scope.list)) {
                $scope.list.NEWSSOURCES = newValue;
            }
        });

        /**
         * [initKeyWords description] 初始化关键词
         * @return  {[type]}  [return description]
         */
        function initKeyWords() {
            if (angular.isDefined($scope.list.KEYWORDS) && $scope.list.KEYWORDS !== '') {
                var KEYWORDS = $scope.list.KEYWORDS.split(';');
                $scope.data.KEYWORDS = [];
                angular.forEach(KEYWORDS, function(data, index, array) {
                    $scope.data.KEYWORDS.push({
                        name: data,
                    });
                });
            } else {
                $scope.data.KEYWORDS = [];
            }
        }
        // 检验关键词的总个数和总记录长度
        $scope.invalidTag = function(tag) {
            var reg = /^[^<>\/]*$/;
            if (tag.name.length > 20) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '单个关键词长度不能超过20';
            }
            if (!reg.test(tag.name)) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '不能包含特殊字符';
            }
        };
        $scope.checkTag = function(tag) {
            var len = $scope.data.KEYWORDS.length;
            if (len == 10) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '关键词个数不能超过10个';
                return false;
            } else {
                $scope.keywordsTips = '';
                $scope.isShowKeywordTips = false;
            }
            if (tag.name.indexOf(' ') > -1) {
                var spaceArr = tag.name.split(' ');
                $timeout(function() {
                    $scope.data.KEYWORDS.pop();
                    var containArr = [];
                    for (var j = 0; j < $scope.data.KEYWORDS.length; j++) {
                        containArr.push($scope.data.KEYWORDS[j].name);
                    }
                    for (var i = 0; i < spaceArr.length; i++) {
                        if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                            $scope.data.KEYWORDS.push({ name: spaceArr[i] });
                            containArr.push(spaceArr[i]);
                        }
                    }
                });
            }
        };
        $scope.leave = function() {
            $scope.isShowKeywordTips = false;
        };
        $scope.enter = function() {
            var reg = /^[^<>\/]*$/;
            if (angular.isDefined($scope.KEYWORDTEXT) && (!reg.test($scope.KEYWORDTEXT) || $scope.KEYWORDTEXT.length > 20)) {
                $scope.isShowKeywordTips = true;
            }

            /* if (angular.isDefined($scope.keywordsTips) && $scope.keywordsTips !== "") {
                $scope.isShowKeywordTips = true;
            }*/
        };

        /**
         * [initArrayBtn description] 初始化权限
         * @return  {[type]}  [return description]
         */
        function initArrayBtn() {
            $scope.methodnameArray = ['iwo.personal', 'iwo.received'];
            $scope.dictionaryArray = [iWoBtnService.initIwoPersonBtn(), iWoBtnService.initIwoReceiveBtn()];
            $scope.iWoBtns = iWoinitBtnService.initBtnArrays()[$stateParams.iwoplatform];
            initeditctrBtnsService.initIwoData($scope.methodnameArray[$stateParams.iwoplatform]).then(function(data) {
                initeditctrBtnsService.initBtns(data, $scope.dictionaryArray[$stateParams.iwoplatform]).then((btns) => {
                    $scope.btnStatus = btns;
                    $scope.arrayBtn = filterEditctrBtnsService.filterBtn($scope.btnStatus, $scope.iWoBtns);
                    addBtn();
                });
            });
        }

        /**
         * [addBtn description] 新增保存关闭按钮
         * @return  {[type]}  [return description]
         */
        function addBtn() {
            $scope.arrayBtn.unshift({
                RIGHTINDEX: 'save',
                OPERDESC: '保存',
                OPERNAME: '保存',
                OPERFUN: 'save',
            });
            $scope.arrayBtn.push({
                RIGHTINDEX: 'close',
                OPERDESC: '关闭',
                OPERNAME: '',
                OPERFUN: 'close',
            });
        }

        /**
         * [politicalCommonSense description]正文政治常识校验
         * @return {[type]} [description]
         */
        $scope.politicalCommonSense = function() {
            editingCenterService.checkoutDraft(ueditorService.bindContent()).then(function(data) {
                if (data.content[0].resultInfo.length > 0) {
                    var ue = UE.getEditor('ueditor');
                    ue.setContent(ueditorService.handlingSensitiveInf(data, ue.getContent()));
                }
            });
        };

        /**
         * [loadDirective description] 动态加载
         * @return  {[type]}  [return description]
         */
        function loadDirective() {
            var defer = $q.defer();
            LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.4', './lib/ueditor2/ueditor.all.js?v=11.4'], function() {
                var ueditor = '<ueditor form="newsForm" versionid = "data.lastVersionid" list="list" infullscreen="status.infullscreen"></ueditor>';
                ueditor = $compile(ueditor)($scope);
                $($(angular.element(document)).find('ueditorLocation')).append(ueditor);
                $scope.status.support.content = $scope.list.CONTENT;
                var ue = UE.getEditor('ueditor');
                ue.ready(function() {
                    ue.addListener('keydown', function(type, event) {
                        if (event.keyCode === 13) {
                            // 获取纯文本
                            $scope.status.support.content = ue.getContentTxt();
                        }
                    });
                    defer.resolve();
                });
                var supportCreation =
                    '<support-creation has-bigface="true" big-face-switch="status.bigFaceSwitch" is-news="true" media-type={{\'0\'}} is-check-sensitive-words="status.isCheckSensitiveWords" list="list"></support-creation>';
                supportCreation = $compile(supportCreation)($scope);
                $($(angular.element(document)).find('supportcreation')).append(supportCreation);
            });
            var draftList =
                '<editor-dir list="list" meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                '<editor-auth-dir author="list.FGD_AUTHINFO" originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $($(angular.element(document)).find('editor')).append(draftList);
            return defer.promise;
        }

        /**
         * [getVersion description] 获取流程版本与操作日志
         * @param   {[type]}  id  [id description]
         * @return  {[type]}      [return description]
         */
        function getVersion(id) {
            var deferred = $q.defer();
            var metadataid = angular.isDefined(id) ? id : $stateParams.iwometadataid;
            editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(function(data) {
                $scope.data.version = data;
                $scope.page = data.page;
                $scope.data.copyVersion = data.copyArray;
                $scope.status.hasVersionTime = true;
                $scope.data.lastVersionid = data.lastVersionid;
                deferred.resolve();
            });
            return deferred.promise;
        }

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function() {
            $scope.page.CURRPAGE++;
            getVersion();
        };

        /**
         * [getComment description] 获取评审意见
         * @param   {[type]}  id        [id description]
         * @param   {[type]}  currPage  [currPage description]
         * @return  {[type]}            [return description]
         */
        function getComment(id, currPage) {
            editingCenterService.getComment(id, currPage).then(function(data) {
                if (
                    angular.isDefined($scope.data.comment.comment[$scope.data.comment.comment.length - 1]) &&
                    $filter('date')($scope.data.comment.comment[$scope.data.comment.comment.length - 1].day, 'yyyy-MM-dd').toString() ==
                        $filter('date')(data.comment[0].day, 'yyyy-MM-dd').toString()
                ) {
                    $scope.data.comment.comment[$scope.data.comment.comment.length - 1].times = $scope.data.comment.comment[
                        $scope.data.comment.comment.length - 1
                    ].times.concat(data.comment[0].times);
                    data.comment.shift();
                }
                $scope.data.comment['comment'] = $scope.data.comment['comment'].concat(data.comment);
                $scope.data.comment.hasMore = data.hasMore;
                for (var i in data.voiceObj) {
                    $scope.data.comment.voiceObj[i] = data.voiceObj[i];
                }
            });
        }

        /**
         * [getComment description]获取评审意见
         * @return {[type]} [description]
         */
        $scope.getLoadMoreComment = function() {
            $scope.data.comment.currPage += 1;
            getComment($stateParams.iwometadataid, $scope.data.comment.currPage);
        };

        /**
         * [trustUrl description]信任url
         */
        $scope.trustUrl = $sce.trustAsResourceUrl;

        /**
         * [initMediaTypes description]初始化渠道类型
         * @return {[type]} [description]
         */
        function initMediaTypes() {
            initSingleSelecet.getChannelList().then(function(data) {
                $scope.status.mediaTypes = data;
            });
        }

        /**
         * [initDocgenre description]初始化稿件体裁
         * @return {[type]} [description]
         */
        function initDocgenre() {
            iWoService.initData().then(function(data) {
                $scope.DOCGENRES = data.DocGenre;
                $scope.list.DOCGENRE = angular.copy($scope.DOCGENRES[0]);
            });
        }

        /**
         * [getKeywordsOrAbstract description]获得关键词或者摘要
         * @param  {[str]} type [description]种类
         * @return {[type]}      [description]
         */
        $scope.getKeywordsOrAbstract = function(type) {
            editingCenterService.getKeywordsOrAbstract(type, ueditorService.bindContent()).then(
                function(data) {
                    if (type === 'keywords') {
                        if (data !== '""') {
                            var keywordsArray = data.substring(1, data.length - 1).split(';');
                            var arr = [];
                            angular.forEach(keywordsArray, function(value, key) {
                                arr.push({
                                    name: value,
                                });
                            });
                            $scope.data.KEYWORDS = $scope.data.KEYWORDS.concat(arr);
                            $scope.data.KEYWORDS = $filter('unique')($scope.data.KEYWORDS, 'name');
                        } else {
                            return;
                        }
                    }
                    if (type === 'abstract') {$scope.list.ABSTRACT = data.substring(1, data.length - 1);}
                },
                function(data) {}
            );
        };

        /**
         * [clearAllKeywords description]清空关键词
         * @return {[type]} [description]
         */
        $scope.clearAllKeywords = function() {
            $scope.data.KEYWORDS = [];
        };

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function(item) {
            var path = $scope.data.path[item.MEDIATYPE];
            var params = {
                objectversionid: item.OBJECTVERSIONID,
            };
            var url = $state.href(path, params);
            $window.open(url);
        };
    },
]);
